export default __webpack_public_path__ + "static/media/create-session.536623f8.svg";